//@ts-nocheck
import { METHOD_FOR_CHART_SOCKET, SOCKET_SUBSCRIPTION_METHODS, OPT_FOR_CHART_SOCKET, UNSUBS_METHOD_FOR_CHART_SOCKET } from "../../utils/constant";
import { extractSymbolParts, sortDataformarketDepth, getExch_Exchtype_Scripcode, bringToFront } from "../../helpers";
import { getFutOptStockDetails, getSIPReturns, getCashFilterData } from "./marketDepthPopupApi";
import { populateStockData, populateSymbolLtp, openOrderDialog, getStockType, intiailiseIndiceList } from "./marketDepthMain";
import { getCompanyDetail } from "./companyDetails";
import { callingElasticSearch } from "../elasticSearch";
import { initDepthSocket, subscribeToDepthData, unsubscribeDataBySubscriberM } from "../../utils/depthwrapper";
import { init5DepthSocket, subscribeTo5DepthData, unsubscribeDataByScrip5Depth } from "../../utils/new_depthwrapper";
import { subscribeToData, unsubscribeDataBySubscriber, } from "../../utils/websocketwrapper";
let currentFetchController = null;
let refreshInterval = null;
let marketDepthSocket = null;
let intervalId = undefined;
let currentSymbol;
let currentScripCode;
let prevSymbol;
let nseScripCode;
let bseScripCode;
let isdepthSocketConnected = false;
let intialisedIndice = false;
let depthViewState = {
    isExpanded: false,
    currentExchange: ''
};
let is5depthshow = true;
let localclientCode = localStorage.getItem("ClientCode");
let currentSkip = 0;
const itemsPerPage = 10;
const totalItems = 100;
let isLoading = false;
let currentFilter = "";
let currentSearchInput = "";
let stockTickers = [];
let loadMoreDebounceTimer;
let searchDebounceTimer = null;
let isSearching = false;
let ismarketDepthOpen = false;
window.__popupZIndex = window.__popupZIndex || 1000;
function formatFutDate(dateStr) {
    if (!dateStr)
        return "";
    const parts = dateStr.split(" ");
    if (parts.length !== 3)
        return dateStr;
    const [day, month, year] = parts;
    const shortYear = year.slice(-2);
    return `${day} ${month}'${shortYear}`;
}
// Function to create company header
function createCompanyHeader(stock) {
    const { ShortName, Exch, FullName, Name, ScripCode, ExchType } = stock;
    const dateRegex = /(\d{2})\s([A-Za-z]{3})\s(\d{4})/;
    const hasDate = dateRegex.test(FullName);
    const hasOption = /(CE|PE)/.test(FullName);
    let exchange = '';
    if (hasDate) {
        exchange = 'NFO';
    }
    else {
        switch (Exch) {
            case 'B':
                exchange = 'BSE';
                break;
            case 'N':
                exchange = 'NSE';
                break;
            case 'M':
                exchange = 'MCX';
                break;
            default:
                exchange = 'NSE';
        }
    }
    const headerDiv = document.createElement('div');
    headerDiv.classList.add('tt-header__value', 'd-flex', 'justify-content-between', 'align-items-center');
    const companyNameDiv = document.createElement('div');
    companyNameDiv.classList.add('company__name');
    const companyNameContent = document.createElement('div');
    companyNameContent.classList.add('d-flex', 'align-items-center', 'cur-point');
    const companyNameInnerDiv = document.createElement('div');
    const firstSection = document.createElement('div');
    firstSection.classList.add('d-flex', 'align-items-center', 'gap_6', 'cur-point');
    const companyNameSpan = document.createElement('span');
    companyNameSpan.classList.add('name');
    companyNameSpan.setAttribute('title', ShortName);
    if (ExchType === "C" && Name.length > 12) {
        companyNameSpan.textContent = Name.slice(0, 12) + '...';
    }
    else if (ExchType === "D" && ShortName.length > 12) {
        companyNameSpan.textContent = ShortName.slice(0, 12) + '...';
    }
    else {
        companyNameSpan.textContent = ExchType === "C" ? Name : ShortName;
    }
    const stockNameSpan = document.createElement('span');
    stockNameSpan.classList.add('stockname', exchange);
    stockNameSpan.textContent = exchange;
    firstSection.appendChild(companyNameSpan);
    firstSection.appendChild(stockNameSpan);
    const secondSection = document.createElement('div');
    secondSection.classList.add('d-flex', 'align-items-center', 'gap_6', 'cur-point');
    const displayContent = document.createDocumentFragment();
    if (hasDate) {
        const dateMatch = FullName.match(dateRegex);
        const day = dateMatch[1];
        const month = dateMatch[2].toUpperCase();
        const year = dateMatch[3].slice(-2);
        const formattedDate = `${day} ${month}'${year}`;
        const dateSpan = document.createElement('span');
        dateSpan.textContent = formattedDate + ' ';
        displayContent.appendChild(dateSpan);
        const optionMatch = FullName.match(/\b(CE|PE)\b/);
        if (optionMatch) {
            const optionSpan = document.createElement('span');
            optionSpan.textContent = optionMatch[0] + ' ';
            optionSpan.style.color = optionMatch[0] === 'CE' ? '#00B29E' : '#E5455D';
            displayContent.appendChild(optionSpan);
            const strikeMatch = Name.match(/(\d+\.\d{2})$/);
            if (strikeMatch) {
                displayContent.appendChild(document.createTextNode(strikeMatch[0]));
            }
        }
        else {
            const futSpan = document.createElement('span');
            futSpan.textContent = 'FUT';
            futSpan.style.color = '#2E90FA';
            displayContent.appendChild(futSpan);
        }
    }
    else {
        displayContent.appendChild(document.createTextNode(FullName));
    }
    const companyDetailsSpan = document.createElement('span');
    companyDetailsSpan.classList.add('companydetails');
    companyDetailsSpan.appendChild(displayContent);
    const cashSpan = document.createElement('span');
    cashSpan.classList.add('CASH');
    const emptyDetailsSpan = document.createElement('span');
    emptyDetailsSpan.classList.add('companydetails');
    secondSection.appendChild(companyDetailsSpan);
    secondSection.appendChild(cashSpan);
    secondSection.appendChild(emptyDetailsSpan);
    companyNameInnerDiv.appendChild(firstSection);
    companyNameInnerDiv.appendChild(secondSection);
    companyNameContent.appendChild(companyNameInnerDiv);
    companyNameDiv.appendChild(companyNameContent);
    companyNameDiv.addEventListener('click', () => {
        const exchName = Exch === 'N' ? 'NSE' : Exch === 'B' ? 'BSE' : 'MCX';
        const ticker = `${exchName}:${Name.replace(/\//g, ' ')}/${ScripCode}-${ExchType}`;
        const uppercaseTicker = ticker.toUpperCase();
        openMarketDepthDropDown(uppercaseTicker, 'fromSearch');
        const dropdown = document.querySelector('.tt-header__dropdown');
        const stockContainer = document.querySelector('.overflow-y-auto');
        document.querySelector('.globalClose svg').classList.add('hidden');
        document.querySelector('#closePopup').classList.remove("hidden");
        const searchInput = marketDepthModal.querySelector('#searchInput');
        if (searchInput) {
            searchInput.value = '';
            searchInput.setAttribute('readonly', 'true');
        }
        if (dropdown) {
            dropdown.classList.add('hidden');
        }
        if (stockContainer)
            stockContainer.innerHTML = '';
    });
    const priceDiv = document.createElement('div');
    priceDiv.classList.add('d-flex', 'align-items-center');
    const priceContainer = document.createElement('div');
    priceContainer.classList.add('comp_ltp');
    const priceElement = document.createElement('div');
    priceElement.classList.add('company__price');
    const priceValue = document.createElement('div');
    priceValue.id = `ltp-${ScripCode}`;
    priceValue.textContent = '0.00';
    priceElement.appendChild(priceValue);
    priceContainer.appendChild(priceElement);
    priceDiv.appendChild(priceContainer);
    headerDiv.appendChild(companyNameDiv);
    headerDiv.appendChild(priceDiv);
    return headerDiv;
}
// handle infinite scroll and store tickers
export function generateStockList(stocks) {
    const stockContainer = document.querySelector('.overflow-y-auto');
    stocks.forEach(stock => {
        const { Exch, Name, ScripCode, ExchType } = stock;
        const exchName = Exch === 'N' ? 'NSE' : Exch === 'B' ? 'BSE' : 'MCX';
        const ticker = `${exchName}:${Name.replace(/\//g, ' ')}/${ScripCode}-${ExchType}`;
        const uppercaseTicker = ticker.toUpperCase();
        if (!stockTickers.includes(uppercaseTicker)) {
            stockTickers.push(uppercaseTicker);
        }
        const companyRow = createCompanyHeader(stock);
        stockContainer.appendChild(companyRow);
    });
    isLoading = false;
    socketConnectioLtp(stockTickers);
}
function showLoader() {
    const loaderDiv = document.querySelector('.Loader');
    if (loaderDiv) {
        loaderDiv.classList.remove('hidden');
    }
}
function hideLoader() {
    const loaderDiv = document.querySelector('.Loader');
    if (loaderDiv) {
        loaderDiv.classList.add('hidden');
    }
}
// Function to load more search results
async function loadMoreItems() {
    if (isLoading || currentSkip + itemsPerPage > totalItems) {
        return;
    }
    clearTimeout(loadMoreDebounceTimer);
    loadMoreDebounceTimer = setTimeout(async () => {
        isLoading = true;
        try {
            showLoader();
            const formattedInput = currentSearchInput.replace(/ /g, '*+');
            const searchResults = await callingElasticSearch(formattedInput, currentFilter, currentSkip, itemsPerPage);
            generateStockList(searchResults);
            currentSkip += itemsPerPage;
        }
        catch (error) {
            console.error('Failed to load more stocks:', error);
        }
        finally {
            hideLoader();
            isLoading = false;
        }
    }, 500);
}
function polulateTotalBuySell(data, exchange, Symbol) {
    const totalBuyQun = document.getElementById("totalBuyQ");
    const totalSellQun = document.getElementById("totalSellQ");
    const totalLeft = document.querySelector(".totalLeft");
    const totalRight = document.querySelector(".totalRight");
    const totalBuyQuantity = data && data.tBidQ ? Number(data.tBidQ) : 0;
    const totalSellQuantity = data && data.tOffQ ? Number(data.tOffQ) : 0;
    totalBuyQun.textContent = Math.round(totalBuyQuantity).toLocaleString('en-IN');
    totalSellQun.textContent = Math.round(totalSellQuantity).toLocaleString('en-IN');
    const totalQ = totalBuyQuantity + totalSellQuantity;
    const buyPercentage = totalQ > 0 ? (totalBuyQuantity / totalQ) * 100 : 50;
    const sellPercentage = totalQ > 0 ? (totalSellQuantity / totalQ) * 100 : 50;
    if (totalLeft)
        totalLeft.style.width = `${buyPercentage}%`;
    if (totalRight)
        totalRight.style.width = `${sellPercentage}%`;
}
function populateDepthData(data, exchange, Symbol) {
    const bidContainer = document.querySelector(".orderListTableLeft");
    const askContainer = document.querySelector(".orderListTableRight");
    const orderListTableBody = document.querySelector(".orderListTableBody");
    const toggleButton = document.querySelector(".btnPlainBlue");
    if (exchange !== depthViewState.currentExchange) {
        depthViewState.isExpanded = false;
        depthViewState.currentExchange = exchange;
    }
    if (orderListTableBody) {
        orderListTableBody.style.height = depthViewState.isExpanded ? "auto" : "116px";
    }
    if (toggleButton) {
        if (!toggleButton.dataset.listenerAttached) {
            toggleButton.addEventListener("click", () => {
                depthViewState.isExpanded = !depthViewState.isExpanded;
                marketDepthSocketConnection(currentSymbol, !depthViewState.isExpanded);
                updateView();
            });
            toggleButton.dataset.listenerAttached = "true";
        }
        updateToggleButton();
    }
    updateView();
    function updateView() {
        if (orderListTableBody) {
            orderListTableBody.style.height = depthViewState.isExpanded ? "auto" : "116px";
        }
        updateToggleButton();
        renderRows();
    }
    function updateToggleButton() {
        if (!toggleButton)
            return;
        toggleButton.innerHTML = depthViewState.isExpanded ? 'View Less Depth' : 'View More Depth';
        let icon = toggleButton.querySelector('.dropdownIconBlue');
        if (!icon) {
            icon = document.createElement('span');
            icon.className = 'dropdownIconBlue ml-4';
            toggleButton.appendChild(icon);
        }
        icon.style.transform = depthViewState.isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
    }
    function renderRows() {
        if (!bidContainer || !askContainer)
            return;
        bidContainer.innerHTML = "";
        askContainer.innerHTML = "";
        const defaultRowCount = exchange.toLowerCase() === "n" ? 6 : 5;
        const totalRows = depthViewState.isExpanded ? 20 : defaultRowCount;
        const bids = data.bidPrice || [];
        const asks = data.askPrice || [];
        const maxBidVol = Math.max(...bids.map(b => b.volume), 1);
        const maxAskVol = Math.max(...asks.map(a => a.volume), 1);
        function createRow({ order = 0, volume = 0, price = 0 }, side, maxVol) {
            const row = document.createElement("div");
            row.className = "orderListTableRow";
            const priceCol = document.createElement("div");
            priceCol.className = "orderListTableColumn";
            const priceColor = side === "sell" ? "#e5455d" : "#00b29e";
            priceCol.innerHTML = `
            <span style="color: ${priceColor}">${Number(price).toFixed(2)}</span>
            <span class="orderListTableBar orderListTableBar${side === "buy" ? "Buy" : "Sell"}"
                  style="width: ${Math.round((volume / maxVol) * 100)}%;"></span>`;
            priceCol.addEventListener("click", () => {
                openOrderDialog(Symbol, side === "buy" ? false : true, 1, Number(price));
            });
            const orderCol = document.createElement("div");
            orderCol.className = "orderListTableColumn";
            orderCol.textContent = Math.round(Number(order)).toLocaleString('en-IN');
            const volCol = document.createElement("div");
            volCol.className = "orderListTableColumn";
            volCol.textContent = Math.round(Number(volume)).toLocaleString('en-IN');
            if (side === "buy") {
                row.append(orderCol, volCol, priceCol);
            }
            else {
                row.append(priceCol, volCol, orderCol);
            }
            return row;
        }
        for (let i = 0; i < totalRows; i++) {
            const bid = bids[i] || {};
            bidContainer.appendChild(createRow(bid, "buy", maxBidVol));
            const ask = asks[i] || {};
            askContainer.appendChild(createRow(ask, "sell", maxAskVol));
        }
    }
}
// WebSocket connection & Marketdepth API function (unchanged)
export async function marketDepthSocketConnection(symbol, is5Depth) {
    is5depthshow = is5Depth;
    let exCh = symbol.split(":")[0];
    let exChange = exCh.split("")[0];
    let exchType = symbol.split("-")[1];
    let scripCode = symbol.split("/")[1].split("-")[0];
    populateDepthData({}, exCh, currentSymbol);
    polulateTotalBuySell({}, exCh, currentSymbol);
    initDepthSocket();
    if (is5Depth) {
        init5DepthSocket();
        subscribeTo5DepthData({
            ClientCode: localclientCode,
            Method: SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE,
            Operation: METHOD_FOR_CHART_SOCKET,
            MarketFeedData: [
                {
                    Exch: exChange,
                    ScripCode: scripCode,
                    ExchType: exchType,
                },
            ],
        }, ("MarketDepth_Dailog" + scripCode), (callbackData) => {
            if (currentScripCode === callbackData.Token && callbackData != null) {
                let DOMData = sortDataformarketDepth(callbackData);
                polulateTotalBuySell(DOMData, exCh, currentSymbol);
                if (is5depthshow) {
                    populateDepthData(DOMData, exCh, currentSymbol);
                }
            }
        });
    }
    else {
        if (exChange === "N" && (exchType === "C" || exchType === "D")) {
            if (!isdepthSocketConnected) {
                initDepthSocket();
                isdepthSocketConnected = true;
            }
            marketDepthSocket = subscribeToDepthData({
                Method: METHOD_FOR_CHART_SOCKET,
                Operation: SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE,
                MarketFeedData: [
                    {
                        Exch: exChange,
                        ScripCode: scripCode,
                        ExchType: exchType,
                    },
                ],
            }, ("MarketDepth_Dailog" + scripCode), false, (callbackData) => {
                if (!is5depthshow && currentScripCode === callbackData.Token && callbackData != null) {
                    let DOMData = sortDataformarketDepth(callbackData);
                    populateDepthData(DOMData, exCh, currentSymbol);
                }
            });
        }
    }
}
async function socketConnectioLtp(symbols) {
    document.getElementById('stockPrice').textContent = "0.00";
    let perChSymbolElement = document.getElementById('perChSymbol');
    perChSymbolElement.textContent = "0.00%";
    symbols.forEach((name) => {
        let resultSubs = getExch_Exchtype_Scripcode(name);
        subscribeToData({
            Method: OPT_FOR_CHART_SOCKET,
            Operation: METHOD_FOR_CHART_SOCKET,
            MarketFeedData: [
                {
                    Exch: resultSubs.Exch,
                    ScripCode: resultSubs.ScripCode,
                    ExchType: resultSubs.ExchType,
                },
            ],
        }, ("MarketDepth_Dailog" + resultSubs.ScripCode), (barData) => {
            if (currentScripCode === barData.Token) {
                populateSymbolLtp(barData, currentSymbol);
            }
            const ltpDiv = document.getElementById(`ltp-${barData.Token}`);
            if (ltpDiv) {
                ltpDiv.textContent = barData.LastRate.toFixed(2);
            }
        });
    });
}
function cleanupMarketDepthConnection(symbol) {
    let result = getExch_Exchtype_Scripcode(symbol);
    unsubscribeDataBySubscriberM("MarketDepth_Dailog" + result.ScripCode, "Unsubscribe");
    unsubscribeDataByScrip5Depth(("MarketDepth_Dailog" + result.ScripCode), {
        Exch: result.Exch,
        ScripCode: result.ScripCode,
        ExchType: result.ExchType,
    }, SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE);
    if (intervalId !== undefined) {
        clearTimeout(intervalId);
        intervalId = undefined;
    }
}
async function reCallDepth(newExchange, symbol, nseScripCode, bseScripCode) {
    if (nseScripCode === 0 || bseScripCode === 0)
        return;
    const { exChange, exchangeType, scripCode, stockName, date, optionType, strikePrice } = extractSymbolParts(symbol);
    let newScripCode;
    if (newExchange === "NSE") {
        newScripCode = nseScripCode;
    }
    else {
        newScripCode = bseScripCode;
    }
    const ticker = `${newExchange}:${stockName.replace(/\//g, ' ')}/${newScripCode}-${exchangeType}`;
    if (ticker === currentSymbol)
        return;
    openMarketDepthDropDown(ticker, "fromToggle");
}
function cleanupSocketConnection(symbol) {
    let resultSubs = getExch_Exchtype_Scripcode(symbol);
    unsubscribeDataBySubscriber("MarketDepth_Dailog" + resultSubs.ScripCode, UNSUBS_METHOD_FOR_CHART_SOCKET);
}
// Openig MarketDepth Dailog
export async function openMarketDepthDropDown(symbol, source) {
    var _a, _b, _c, _d, _e;
    depthViewState = {
        isExpanded: false,
        currentExchange: ''
    };
    currentSymbol = symbol;
    if (currentFetchController) {
        currentFetchController.abort();
        currentFetchController = null;
    }
    if (refreshInterval) {
        clearInterval(refreshInterval);
        refreshInterval = null;
    }
    if (prevSymbol) {
        cleanupMarketDepthConnection(prevSymbol);
        if (prevSymbol !== currentSymbol) {
            cleanupMarketDepthConnection(currentSymbol);
        }
        if (prevSymbol !== currentSymbol) {
            cleanupSocketConnection(currentSymbol);
        }
    }
    const { exChange, exchangeType, scripCode, stockName, date, optionType, strikePrice } = extractSymbolParts(symbol);
    prevSymbol = symbol;
    currentScripCode = Number(scripCode);
    const marketDepthModal = document.getElementById('marketDepthModal');
    const marketDepthModalDrag = document.getElementById('marketDepthModalDrag');
    if (!marketDepthModal)
        return;
    const searchDropdown = marketDepthModal.querySelector('.tt-header__dropdown');
    const searchInput = marketDepthModal.querySelector('#searchInput');
    const closeButton = marketDepthModal.querySelector('#closePopup');
    const stockContainer = document.querySelector('.overflow-y-auto');
    const headerLinks = marketDepthModal.querySelectorAll('.header__links a');
    const progressBars = document.querySelectorAll('.progressBarWrapper');
    const symbolName = document.querySelector('#symbolName');
    const symbolScripData = document.querySelector('#symbolScripData');
    const exchangeBtn = document.querySelectorAll('.tabWrap span');
    const tabWrap = document.querySelector('.tabWrap');
    const buyButton = document.querySelector('.buy');
    const sellButton = document.querySelector('.sell');
    const DepthD = document.querySelector('.DepthData');
    const placeholderImg = document.querySelector(".tt-placeholder__img-wrapper");
    bringToFront(marketDepthModal);
    symbolName.textContent = stockName;
    symbolScripData.innerHTML = date
        ? optionType
            ? `${formatFutDate(date)} <span style="color: ${optionType === 'CE' ? '#00B29E' : '#E5455D'};">${optionType}</span> ${strikePrice === null || strikePrice === void 0 ? void 0 : strikePrice.toFixed(2)}`
            : `FUT ${formatFutDate(date)}`
        : "";
    buyButton === null || buyButton === void 0 ? void 0 : buyButton.addEventListener('click', () => {
        openOrderDialog(currentSymbol, true);
    });
    sellButton === null || sellButton === void 0 ? void 0 : sellButton.addEventListener('click', () => {
        openOrderDialog(currentSymbol, false);
    });
    if (!intialisedIndice) {
        await intiailiseIndiceList();
        intialisedIndice = true;
    }
    currentSkip = 0;
    isLoading = false;
    currentSearchInput = "";
    const handleScroll = () => {
        if (isLoading || !stockContainer)
            return;
        const scrollPosition = stockContainer.scrollTop + stockContainer.clientHeight;
        const containerHeight = stockContainer.scrollHeight - 100;
        if (scrollPosition >= containerHeight) {
            loadMoreItems();
        }
    };
    stockContainer === null || stockContainer === void 0 ? void 0 : stockContainer.addEventListener('scroll', handleScroll);
    currentFetchController = new AbortController();
    let isDragging = false;
    let startX = 0, startY = 0;
    let initialLeft = 0, initialTop = 0;
    let symType = await getStockType(symbol);
    let rollOver = "";
    let rollCost = "";
    let return1M = "";
    let return3M = "";
    let return1Y = "";
    let stockType = "";
    let isonlyNSEBSE = false;
    let searchDebounceTimer;
    stockType = (symType === "nifty_index" || symType === "bank_index") ? "index" : symType;
    if (exChange !== "M" && exchangeType === "C") {
        try {
            const response = await getCashFilterData(currentSymbol);
            if (response &&
                response.lstCashScrip &&
                response.lstCashScrip.length > 0) {
                const scrip = response.lstCashScrip[0];
                if (exChange === "N") {
                    nseScripCode = scrip.NseBseCode;
                    bseScripCode = scrip.ScripCode;
                }
                else {
                    bseScripCode = scrip.NseBseCode;
                    nseScripCode = scrip.ScripCode;
                }
            }
            else {
                isonlyNSEBSE = true;
                nseScripCode = 0;
                bseScripCode = 0;
            }
        }
        catch (error) {
            console.log("Error while calling getCashFilterData:", error);
        }
    }
    if (!ismarketDepthOpen) {
        setTimeout(() => {
            let isDragging = false;
            let startX = 0, startY = 0;
            let initialLeft = 0, initialTop = 0;
            let animationFrameId;
            const centerModal = () => {
                const { innerWidth, innerHeight } = window;
                let modalRect = marketDepthModal.getBoundingClientRect();
                marketDepthModal.style.position = 'fixed';
                if (modalRect.width === 0 || modalRect.height === 0) {
                    modalRect = {
                        width: marketDepthModal.offsetWidth || 360,
                        height: marketDepthModal.offsetHeight || 430
                    };
                }
                const left = Math.max(10, (innerWidth - modalRect.width) / 2);
                const top = Math.max(10, (innerHeight - modalRect.height) / 2);
                marketDepthModal.style.left = `${left}px`;
                marketDepthModal.style.top = `${top}px`;
                initialLeft = left;
                initialTop = top;
            };
            centerModal();
            const startDrag = (e) => {
                if (!e.target.closest('#marketDepthModalDrag'))
                    return;
                isDragging = true;
                startX = e.clientX;
                startY = e.clientY;
                const computedStyle = window.getComputedStyle(marketDepthModal);
                initialLeft = parseInt(computedStyle.left) || 0;
                initialTop = parseInt(computedStyle.top) || 0;
                marketDepthModal.style.cursor = 'grabbing';
                marketDepthModal.style.userSelect = 'none';
                document.body.style.cursor = 'grabbing';
                e.preventDefault();
                e.stopPropagation();
            };
            const drag = (e) => {
                if (!isDragging)
                    return;
                cancelAnimationFrame(animationFrameId);
                animationFrameId = requestAnimationFrame(() => {
                    const { innerWidth, innerHeight } = window;
                    const modalRect = marketDepthModal.getBoundingClientRect();
                    const dx = e.clientX - startX;
                    const dy = e.clientY - startY;
                    let newLeft = initialLeft + dx;
                    let newTop = initialTop + dy;
                    newLeft = Math.max(10, Math.min(innerWidth - modalRect.width - 10, newLeft));
                    newTop = Math.max(10, Math.min(innerHeight - modalRect.height - 10, newTop));
                    marketDepthModal.style.left = `${newLeft}px`;
                    marketDepthModal.style.top = `${newTop}px`;
                });
                e.preventDefault();
            };
            const stopDrag = () => {
                if (!isDragging)
                    return;
                cancelAnimationFrame(animationFrameId);
                isDragging = false;
                marketDepthModal.style.cursor = '';
                marketDepthModal.style.userSelect = '';
                document.body.style.cursor = '';
            };
            const handleScroll = (e) => {
                if (isDragging) {
                    e.preventDefault();
                    return;
                }
                const target = e.target;
                const isInsideModal = marketDepthModal.contains(target);
                const isScrollable = target.scrollHeight > target.clientHeight;
            };
            marketDepthModalDrag.addEventListener('mousedown', startDrag, { passive: false });
            document.addEventListener('mousemove', drag, { passive: false });
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('mouseleave', stopDrag);
            document.addEventListener('wheel', handleScroll, { passive: false });
            window.addEventListener('resize', centerModal);
            const cleanup = () => {
                cancelAnimationFrame(animationFrameId);
                document.removeEventListener('mousemove', drag);
                document.removeEventListener('mouseup', stopDrag);
                document.removeEventListener('mouseleave', stopDrag);
                document.removeEventListener('wheel', handleScroll);
                window.removeEventListener('resize', centerModal);
                marketDepthModalDrag.removeEventListener('mousedown', startDrag);
            };
            if ('onclose' in marketDepthModal) {
                marketDepthModal.addEventListener('close', cleanup, { once: true });
            }
        }, 0);
    }
    try {
        await marketDepthSocketConnection(symbol, true);
    }
    catch (error) {
        console.log("error is getting in depth data");
    }
    try {
        await socketConnectioLtp(Array(symbol));
    }
    catch (error) {
        console.log("error is getting in depth data");
    }
    if (searchDropdown)
        searchDropdown.classList.add('hidden');
    if (exChange === "M") {
        exchangeBtn[2].classList.remove('hidden');
        exchangeBtn[0].classList.add('hidden');
        exchangeBtn[1].classList.add('hidden');
        exchangeBtn[3].classList.add('hidden');
    }
    else if (symType === "nifty_index") {
        exchangeBtn[2].classList.add('hidden');
        exchangeBtn[1].classList.add('hidden');
        exchangeBtn[3].classList.add('hidden');
        exchangeBtn[0].classList.remove('hidden');
    }
    else if (symType === "bank_index") {
        exchangeBtn[1].classList.remove('hidden');
        exchangeBtn[2].classList.add('hidden');
        exchangeBtn[0].classList.add('hidden');
        exchangeBtn[3].classList.add('hidden');
    }
    else if (date !== null && exChange !== "M") {
        exchangeBtn[3].classList.remove('hidden');
        exchangeBtn[0].classList.add('hidden');
        exchangeBtn[1].classList.add('hidden');
        exchangeBtn[2].classList.add('hidden');
    }
    else if (exChange === "N" && date === null) {
        exchangeBtn[0].classList.remove('hidden');
        exchangeBtn[0].classList.add('active');
        exchangeBtn[1].classList.remove('hidden');
        exchangeBtn[1].classList.remove('active');
        exchangeBtn[2].classList.add('hidden');
        exchangeBtn[3].classList.add('hidden');
    }
    else if (isonlyNSEBSE) {
        if (exChange === "N" || exChange === "NSE" || exChange === "nse") {
            exchangeBtn[0].classList.remove('hidden');
            exchangeBtn[1].classList.add('hidden');
            exchangeBtn[0].classList.remove('active');
            exchangeBtn[1].classList.remove('active');
            exchangeBtn[2].classList.add('hidden');
            exchangeBtn[3].classList.add('hidden');
        }
        else {
            exchangeBtn[0].classList.add('hidden');
            exchangeBtn[1].classList.remove('hidden');
            exchangeBtn[0].classList.add('active');
            exchangeBtn[1].classList.remove('active');
            exchangeBtn[2].classList.add('hidden');
            exchangeBtn[3].classList.add('hidden');
        }
    }
    else {
        exchangeBtn[0].classList.remove('hidden');
        exchangeBtn[1].classList.remove('hidden');
        exchangeBtn[0].classList.remove('active');
        exchangeBtn[1].classList.add('active');
        exchangeBtn[2].classList.add('hidden');
        exchangeBtn[3].classList.add('hidden');
    }
    if (tabWrap) {
        const initialActiveTab = exChange === 'N' ? 'NSE' : exChange === 'B' ? 'BSE' : '';
        tabWrap.addEventListener('click', function (e) {
            var _a, _b;
            const clickedTab = e.target.closest('span');
            if (!clickedTab)
                return;
            const tabName = (_a = clickedTab.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            if (tabName !== 'NSE' && tabName !== 'BSE')
                return;
            if (stockType === "index")
                return;
            const currentActiveTabEl = tabWrap.querySelector('span.active');
            const currentActiveTab = (_b = currentActiveTabEl === null || currentActiveTabEl === void 0 ? void 0 : currentActiveTabEl.textContent) === null || _b === void 0 ? void 0 : _b.trim();
            if (currentActiveTab === tabName)
                return;
            tabWrap.querySelectorAll('span').forEach(tab => {
                tab.classList.remove('active');
            });
            clickedTab.classList.add('active');
            const newExchange = tabName;
            reCallDepth(newExchange, currentSymbol, nseScripCode, bseScripCode);
        });
    }
    const shouldHideProgressBars = ["option", "future", "commodity_fut", "commodity_opt"].includes(stockType);
    progressBars.forEach(bar => {
        bar.classList.toggle('hidden', shouldHideProgressBars);
    });
    if (stockType === "index") {
        const Exchange = exChange === "N" ? "nse" : exChange === "B" ? "bse" : "mcx";
        try {
            const sipData = await getSIPReturns(Exchange, stockName, {
                signal: currentFetchController === null || currentFetchController === void 0 ? void 0 : currentFetchController.signal
            });
            const performanceData = sipData.response.data.CompanyPerformanceList.CompanyPerformance[0];
            return1M = (Math.round(performanceData.ret1month * 100) / 100).toString();
            return3M = (Math.round(performanceData.ret3month * 100) / 100).toString();
            return1Y = (Math.round(performanceData.ret1year * 100) / 100).toString();
        }
        catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Failed to get SIP returns:', error);
            }
            return1M = '-';
            return3M = '-';
            return1Y = '-';
        }
    }
    if (["future", "commodity_fut", "commodity_opt", "option"].includes(stockType)) {
        try {
            const futOptStockDetails = await getFutOptStockDetails(scripCode, {
                signal: currentFetchController === null || currentFetchController === void 0 ? void 0 : currentFetchController.signal
            });
            const stockList = (_c = (_b = (_a = futOptStockDetails === null || futOptStockDetails === void 0 ? void 0 : futOptStockDetails.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.FutOptIndvidualStockList) === null || _c === void 0 ? void 0 : _c.FutOptIndvidualStock;
            if (Array.isArray(stockList) && stockList.length > 0) {
                rollOver = (_d = stockList[0].RollOver) !== null && _d !== void 0 ? _d : '-';
                rollCost = (_e = stockList[0].RollCost) !== null && _e !== void 0 ? _e : '-';
            }
            else {
                rollOver = '-';
                rollCost = '-';
            }
        }
        catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Failed to get future/option details:', error);
            }
            rollOver = '-';
            rollCost = '-';
        }
    }
    const fetchAndPopulateData = async () => {
        try {
            const controller = new AbortController();
            currentFetchController = controller;
            const res = await getCompanyDetail(exChange, exchangeType, scripCode, { signal: controller.signal });
            const currentAdditionalData = await getAdditionalData(stockType);
            if (res.body.Data[0].Token === currentScripCode) {
                populateStockData(res, stockType, currentAdditionalData);
            }
        }
        catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error fetching data:', error);
            }
        }
    };
    const getAdditionalData = async (stockType) => {
        if (stockType === "index") {
            return {
                returnsData: {
                    '1M_Ret': return1M,
                    '3M_Ret': return3M,
                    '1Y_Ret': return1Y
                }
            };
        }
        if (["future", "commodity_fut", "commodity_opt", "option"].includes(stockType)) {
            return {
                rolloverData: {
                    'Rollover': rollOver,
                    'RolloverCost': rollCost
                }
            };
        }
        return {};
    };
    refreshInterval = setInterval(fetchAndPopulateData, 5000);
    if (exChange === "B" || exChange === "M") {
        document.getElementById("viewMoreDepth").classList.add("hidden");
    }
    else {
        document.getElementById("viewMoreDepth").classList.remove("hidden");
    }
    if (stockType === "index") {
        DepthD.classList.add("hidden");
    }
    else {
        DepthD.classList.remove("hidden");
    }
    stockType === "index" ? DepthD === null || DepthD === void 0 ? void 0 : DepthD.classList.add("hidden") : DepthD === null || DepthD === void 0 ? void 0 : DepthD.classList.remove("hidden");
    marketDepthModal.show();
    ismarketDepthOpen = true;
    await fetchAndPopulateData();
    let isClosing = false;
    const handleClose = () => {
        if (isClosing)
            return;
        isClosing = true;
        if (currentFetchController) {
            currentFetchController.abort();
            currentFetchController = null;
        }
        if (refreshInterval) {
            clearInterval(refreshInterval);
            refreshInterval = null;
        }
        cleanupMarketDepthConnection(symbol);
        cleanupSocketConnection(symbol);
        marketDepthModal.close();
        if (stockContainer) {
            stockContainer.innerHTML = '';
            stockContainer.removeEventListener('scroll', handleScroll);
        }
        placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.add("hidden");
        if (searchInput) {
            searchInput.value = '';
            searchInput.setAttribute('readonly', 'true');
        }
        stockTickers = [];
        ismarketDepthOpen = false;
    };
    closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', handleClose);
    let isSearchActive = false;
    headerLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            var _a;
            e.preventDefault();
            headerLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
            const tabName = (_a = link.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            switch (tabName) {
                case 'All':
                    currentFilter = "";
                    break;
                case 'Equity':
                    currentFilter = "Exch eq 'N' and Series eq 'EQ' or Exch eq 'N' and Series eq 'BE' or Exch eq 'B' and Series ne 'F' and ExchType eq 'C'";
                    break;
                case 'ETF':
                    currentFilter = "SymbolOrder eq 3";
                    break;
                case 'FNO':
                    currentFilter = "Exch eq 'N' and ExchType eq 'D' or Exch eq 'B' and ExchType eq 'D'";
                    break;
                case 'Currency':
                    currentFilter = "ExchType eq 'U' and StrikeRate ge 0 and Expiry ge 0 and Exch ne 'M' and Exch ne 'B'";
                    break;
                case 'Commodity':
                    currentFilter = "Exch eq 'M' and ExchType eq 'D' or Exch eq 'N' and ExchType eq 'X'";
                    break;
                default: currentFilter = "";
            }
            if (searchInput.value.trim().length > 0) {
                currentSkip = 0;
                handleSearchInput({ target: searchInput });
            }
        });
    });
    if (searchInput) {
        searchInput.addEventListener('click', () => {
            document.querySelector('.globalClose svg').classList.remove('hidden');
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.classList.add("hidden");
            if (searchDropdown)
                searchDropdown.classList.remove('hidden');
            placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.add("hidden");
            if (searchInput.hasAttribute('readonly')) {
                searchInput.removeAttribute('readonly');
            }
            if (!isSearchActive) {
                isSearchActive = true;
                searchInput.addEventListener('input', handleSearchInput);
            }
        });
    }
    const handleSearchInput = async (e) => {
        const userInput = e.target.value.trim();
        currentSearchInput = userInput;
        if (searchDebounceTimer) {
            clearTimeout(searchDebounceTimer);
        }
        const formattedInput = userInput.replace(/ /g, '*+');
        if (formattedInput.length <= 2 && formattedInput.length !== 0) {
            return;
        }
        // Set debounce timeout
        searchDebounceTimer = setTimeout(async () => {
            if (isSearching)
                return;
            isSearching = true;
            try {
                if (formattedInput.length === 0) {
                    if (stockContainer)
                        stockContainer.innerHTML = '';
                    placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.add("hidden");
                    hideLoader();
                    return;
                }
                placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.add("hidden");
                if (stockContainer)
                    stockContainer.innerHTML = '';
                showLoader();
                currentSkip = 0;
                stockTickers = [];
                const searchResults = await callingElasticSearch(formattedInput, currentFilter, currentSkip, itemsPerPage);
                if (searchResults.length === 0) {
                    placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.remove("hidden");
                    if (stockContainer)
                        stockContainer.innerHTML = '';
                }
                else {
                    placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.add("hidden");
                    generateStockList(searchResults);
                    currentSkip += itemsPerPage;
                }
            }
            catch (error) {
                console.error('Search failed:', error);
                placeholderImg === null || placeholderImg === void 0 ? void 0 : placeholderImg.classList.remove("hidden");
            }
            finally {
                hideLoader();
                isSearching = false;
            }
        }, 500);
    };
    marketDepthModal.addEventListener('click', function (event) {
        if (event.target === marketDepthModal || event.target === searchInput) {
            searchInput.focus();
            event.preventDefault();
        }
    });
    marketDepthModal.addEventListener('close', function () {
        searchInput.blur();
    });
    marketDepthModal.addEventListener('cancel', function (e) {
        e.preventDefault();
        searchInput.focus();
    });
    marketDepthModal.addEventListener('shown', function () {
        searchInput.focus();
    });
    const globalClose = document.querySelector(".globalClose");
    globalClose === null || globalClose === void 0 ? void 0 : globalClose.addEventListener("click", () => {
        document.querySelector('.globalClose svg').classList.add('hidden');
        closeButton === null || closeButton === void 0 ? void 0 : closeButton.classList.remove("hidden");
        if (searchDropdown)
            searchDropdown.classList.add('hidden');
        if (stockContainer)
            stockContainer.innerHTML = '';
        if (isSearchActive && searchInput) {
            searchInput.removeEventListener('input', handleSearchInput);
            isSearchActive = false;
            searchInput.value = '';
            searchInput.setAttribute('readonly', 'true');
            currentSearchInput = "";
            currentSkip = 0;
            stockTickers = [];
        }
    });
    marketDepthModal.addEventListener('close', handleClose, { once: true });
}
